import React from 'react';
import OrdersListFunctional from './components/orders-list-functional';
import './orders-list.scss';

const OrdersList = () => {
	return <OrdersListFunctional />;
};

export default OrdersList;
